import {
  Grid,
  IconButton,
  InputBase,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { forwardRef, useState, useEffect } from "react";
import { useStyles } from "./GroupDocument.style";
import {
  Container,
  DeleteAlert,
  MTable,
  PaginationTable,
  Panel,
  Pagination,
  ButtonSubmit,
} from "../../../../Components";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { CreateGroup } from "./CreateGroup";
import {
  AddSharp,
  RemoveSharp,
  Edit,
  ChevronRight,
  ViewColumn,
} from "@material-ui/icons";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
import DeleteOutline from "@material-ui/icons/Delete";
import UserGroupServicesApi from "../../../../Redux/Actions/UserGroups/UserGroupAction";
import { useSnackbar } from "notistack";
import { SearchTextField } from "../../../../Components/Field";
import { Hidden } from "@mui/material";
import { MTableToolbar } from "@material-table/core";
export const GroupDocument = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  let { apiToken, currentUser, allUserGroups } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
    allUserGroups: state?.UserGroupReducer?.allUserGroups,
  }));
  useEffect(() => {
    try {
      dispatch(
        UserGroupServicesApi.allUsersGroup(
          currentUser?.customerId,
          apiToken,
          enqueueSnackbar
        )
      );
    } catch (error) {
      console.error(error);
    }
  }, []);
  const [open, setOpen] = useState(false);
  const [userAddOpen, UserAddOpen] = useState(false);
  let [group, setGroup] = useState<any>(null);
  const [reload, setReload] = useState(false);
  let [alertDeleteOpen, setAlertDeleteOpen] = useState<any>(false);
  let [getUserGroup, setGetUserGroup] = useState<any>(null);
  let [selected, setSelected] = useState<any>(20);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch: any = useDispatch();
  const [rotate, setRotate] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  let [dataTable, setTableData] = useState(
    allUserGroups?.length ? allUserGroups : []
  );
  const { enqueueSnackbar } = useSnackbar();

  const handleExpandAll = () => {
    setRotate(!rotate);
    let table = document.getElementsByTagName("table");
    let rows = table[0].getElementsByTagName("tr");
    for (let i = 0; i < rows.length; i++) rows[i].click();
  };

  const columns = [
    {
      title: formatMessage({
        id: "group.user.permission.group",
        defaultMessage: " Permission Groups name",
      }),
      field: "name",
      cellStyle: (cellValue: any, rowData: any) => {
        return {
          fontFamily: `"Work Sans", "Arial", "sans-serif!important"`,
        };
      },
    },
    {
      title: formatMessage({
        id: "group.user.description",
        defaultMessage: "Groups",
      }),
      field: "description",
    },
    {
      title: formatMessage({
        id: "group.user.noOfUsers",
        defaultMessage: "Groups",
      }),
      field: "number",
      render: (rowData: any) => {
        return (
          <div
            style={{ justifyContent: "center", display: "flex", width: "30%" }}
          >
            {rowData?.users.length}
          </div>
        );
      },
      editable: () => {
        return false;
      },
    },
  ];
  const closeBOx = () => setOpen(false);
  const Add = (user: any) => {
    return {
      tooltip: formatMessage({ id: "group.user.add" }),
      icon: () => (
        <Grid className={classes.iconPerson}>
          <AddSharp className={classes.person} />
        </Grid>
      ),
      onClick: () => {
        setGroup(user);
        UserAddOpen(true);
      },
      hidden: currentUser?.role == "ClientAdmin" ? false : true,
    };
  };
  const deleteUserGroup = (user: any) => {
    return {
      tooltip: formatMessage({ id: "component.mtable.deleteTooltip" }),
      icon: "delete",
      onClick: () => {
        setAlertDeleteOpen(true);
        setGetUserGroup(user);
      },
      hidden: currentUser?.role == "ClientAdmin" ? false : true,
    };
  };
  const addUserGroup = () => {
    UserAddOpen(false);
  };
  const removeUser: any = (value: any) => {
    const addUsers = {
      userGroupId: null,
      userIds: [value?.id],
    };
    dispatch(
      UserGroupServicesApi.assignUsersGroup(addUsers, apiToken, enqueueSnackbar)
    );
    setReload(true);
    setTimeout(() => {
      reloadTable();
      dispatch(
        UserSevicesApi.UserListData(
          currentUser?.customerId,
          apiToken,
          enqueueSnackbar
        )
      );
    }, 1000);
  };
  useEffect(() => {
    setTimeout(() => {
      setTableData(allUserGroups?.length ? allUserGroups : []);
    }, 1000);
  }, [allUserGroups]);

  const onhandleChange = (event: any) => {
    setSelected(event?.target?.value);
    let customerId = event?.target?.value;
    dispatch(
      UserGroupServicesApi.allUsersGroup(customerId, apiToken, enqueueSnackbar)
    );
  };
  const reloadTable = () => {
    dispatch(
      UserGroupServicesApi.allUsersGroup(
        currentUser?.customerId,
        apiToken,
        enqueueSnackbar
      )
    );
    setReload(false);
  };
  const setReloadTable = () => {
    setReload(true);
  };

  const createGroupModel = () => setOpen(true);
  const deleteUsersGroup = () => {
    if (getUserGroup?.users?.length != 0) {
      enqueueSnackbar("remove all documemnts from the group first", {
        variant: "error",
      });
      setAlertDeleteOpen(false);
    } else {
      setGroup(getUserGroup);
      setTimeout(() => {
        const index = getUserGroup?.id;
        setReloadTable();
        dispatch(
          UserGroupServicesApi.deleteUsersGroup(
            index,
            apiToken,
            enqueueSnackbar
          )
        );
      }, 1000);
      setTimeout(() => {
        reloadTable();
        setAlertDeleteOpen(false);
      }, 2000);
    }
  };

  let [searchData, setSearchData] = useState("");
  let searchHandle = (str: string) => {
    setSearchData(str);
    if (str) {
      let myData = allUserGroups?.filter((item: any) => {
        let findNameData = item.name.toLowerCase().includes(str.toLowerCase());
        let documentData = item.users?.filter((val: any) =>
          val.firstName.toLowerCase().includes(str.toLowerCase())
        );
        return findNameData || documentData.length > 0;
      });
      setTableData(myData);
    } else {
      setTableData(allUserGroups?.length ? allUserGroups : []);
    }
  };
  const ToolbarComp = ({ props }) => {
    return (
      <Grid container justifyContent="flex-end">
        <Hidden only="xs">
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingLeft: 15 }}
          >
            <ButtonSubmit
              text={"document.group.all.expand.document"}
              onClick={handleExpandAll}
              icon={<ChevronRight />}
              className={`${classes.button} ${rotate ? "rotate" : ""}`}
            />
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SearchTextField
                onChange={searchHandle}
                value={searchData}
                clearSearch={() => {
                  setSearchData("");
                  setTableData(allUserGroups?.length ? allUserGroups : []);
                }}
              />
              <Grid item style={{ marginRight: 10 }}>
                <MTableToolbar {...props} />
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
        <Hidden smUp>
          <Grid container style={{ marginBottom: 15 }} alignItems="center">
            <ButtonSubmit
              text="document.group.all.expand.document"
              onClick={handleExpandAll}
              icon={<ChevronRight />}
              className={`${classes.button} ${rotate ? "rotate" : ""} ${
                classes.lableFontSize
              }`}
            />
            <SearchTextField
              onChange={searchHandle}
              value={searchData}
              clearSearch={() => {
                setSearchData("");
                setTableData(allUserGroups?.length ? allUserGroups : []);
              }}
            />
            <Grid item>
              <MTableToolbar {...props} />
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    );
  };
  const { pagination, toolbar, body, header } = Pagination();
  const ViewColumns = () => {
    const element = document.getElementsByClassName(
      "ViewIcons"
    )[0] as HTMLElement | null;
    if (element) {
      element.click();
    }
  };
  return (
    <div className="userGroup-page-container">
      <Container fullWidth>
      <Panel
        titleKey="group.user"
        titleValues={"modelButton"}
        buttonTitle={"createGroup"}
        handleOpen={createGroupModel}
      >
        <Grid className="table-toolbar-panel">
          <Hidden only="xs">
            <Grid container justifyContent="space-between">
              <ButtonSubmit
                text={"document.group.all.expand.document"}
                onClick={handleExpandAll}
                icon={<ChevronRight />}
                className={`${classes.button} ${rotate ? "rotate" : ""}`}
              />
              <Grid
                style={{
                  marginBottom: 15,
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                }}
              >
                <SearchTextField
                  onChange={searchHandle}
                  value={searchData}
                  clearSearch={() => {
                    setSearchData("");
                    setTableData(allUserGroups?.length ? allUserGroups : []);
                  }}
                />
                <IconButton onClick={ViewColumns}>
                  <ViewColumn />
                </IconButton>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid container style={{ marginBottom: 15 }} alignItems="center">
              <ButtonSubmit
                text="document.group.all.expand.document"
                onClick={handleExpandAll}
                icon={<ChevronRight />}
                className={`${classes.button} ${rotate ? "rotate" : ""} ${
                  classes.lableFontSize
                }`}
              />
              <SearchTextField
                onChange={searchHandle}
                value={searchData}
                clearSearch={() => {
                  setSearchData("");
                  setTableData(allUserGroups?.length ? allUserGroups : []);
                }}
              />
              <IconButton onClick={ViewColumns}>
                <ViewColumn />
              </IconButton>
            </Grid>
          </Hidden>
        </Grid>
        <MTable
          //hideToolbar
          columns={columns}
          data={dataTable}
          parentChildData={(row, rows) =>
            rows.find((a) => a?.id === row?.users?.userGroupId)
          }
          options={{ search: false, actionsColumnIndex: 1 }}
          actions={[Add, deleteUserGroup]}
          isLoading={reload}
          onPageChange={(page, pageSize) => setPage(page)}
          onRowsPerPageChange={(pageSize: any) =>
            setRowsPerPage(parseInt(pageSize, 10))
          }
          onRowClick={(event, rowData, togglePanel: any) => {
            setExpandedRows((prevExpandedRows: any) => {
              const isRowExpanded = prevExpandedRows.includes(rowData.id);
              return isRowExpanded
                ? prevExpandedRows.filter((id) => id !== rowData.tableData.id)
                : [...prevExpandedRows, rowData.tableData.id];
            });
            togglePanel();
          }}
          icons={{
            Delete: forwardRef((props: any, ref: any) => (
              <DeleteOutline
                {...props}
                ref={ref}
                style={group?.id == group?.p ? { marginLeft: 5 } : {}}
              />
            )),
            Edit: forwardRef((props: any, ref: any) => (
              <Edit {...props} ref={ref} />
            )),
            ViewColumn: forwardRef((props: any, ref: any) => (
              <IconButton className="ViewIcons" style={{ display: "None" }}>
                <ViewColumn />
              </IconButton>
            )),
          }}
          localization={{ pagination, toolbar, body, header }}
          detailPanel={({ rowData }) => {
            return rowData?.users?.map((items: any, i: any) => {
              return (
                <Grid
                  key={i}
                  container
                  justifyContent="space-between"
                  className={
                    i == 0 ? classes.panelContainer1 : classes.panelContainer2
                  }
                >
                  <Grid className={classes.panelRow}>
                    {items?.firstName}&nbsp;&nbsp;
                    {items?.lastName}
                  </Grid>
                  <Grid className={classes.panelEmail}>{items?.email}</Grid>
                  <Grid className={classes.deleteIcon}>
                    {currentUser?.role == "ClientAdmin" ? (
                      <Tooltip
                        title={formatMessage({
                          id: "document.table.removeUser",
                          defaultMessage: "Remove User",
                        })}
                        placement="bottom-end"
                      >
                        <IconButton onClick={() => removeUser(items)}>
                          <RemoveSharp className={classes.icon} />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Grid>
                </Grid>
              );
            });
          }}
          editable={{
            onRowUpdate: (newData: any, oldData) => {
              return new Promise((resolve, reject) => {
                const userData = {
                  name: newData?.name,
                  description: newData?.description,
                  customerId: newData?.customerId,
                };
                setReload(true);
                dispatch(
                  UserGroupServicesApi.updateUserGroup(
                    userData,
                    newData?.id,
                    apiToken,
                    enqueueSnackbar
                  )
                );
                setTimeout(() => {
                  dispatch(
                    UserGroupServicesApi.allUsersGroup(
                      currentUser?.customerId,
                      apiToken,
                      enqueueSnackbar
                    )
                  );
                  resolve(currentUser);
                  setReload(false);
                }, 2000);
              });
            },
          }}
          components={{
            Pagination: (props: any) => (
              <Grid component="td" container>
                <Grid item xs={6}>
                  <Typography className={classes.total}>
                    {formatMessage({ id: "component.mtable.total" })}
                    &nbsp;{dataTable?.length}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <PaginationTable
                    props={props}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    count={dataTable}
                  />
                </Grid>
              </Grid>
            ),
            // Toolbar:props=>(
            //   <ToolbarComp props={props}/>
            // )
          }}
        />
      </Panel>
      <DeleteAlert
        alertClose={() => setAlertDeleteOpen(false)}
        alertOpen={alertDeleteOpen}
        componentName={"group.user"}
        Submited={deleteUsersGroup}
        deletedValue={getUserGroup?.name}
      />
      <CreateGroup
        handleClose={closeBOx}
        open={open}
        addopen={userAddOpen}
        addUserClose={addUserGroup}
        group={group}
        forceReload={reloadTable}
        setReload={setReloadTable}
      />
      </Container>
    </div>
  );
};
